import { render, staticRenderFns } from "./TabContents.vue?vue&type=template&id=dc74b6ae&"
import script from "./TabContents.vue?vue&type=script&lang=ts&"
export * from "./TabContents.vue?vue&type=script&lang=ts&"
import style0 from "./TabContents.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports